module.exports = __webpack_public_path__ + "static/home-header-bg-2c3048b9bebfd48080106649e616692f.png";